/* eslint-disable @typescript-eslint/no-var-requires */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const en = require('./translations/en.json');
const hi = require('./translations/hi.json');
const ar = require('./translations/ar.json');
const ba = require('./translations/ba.json');
const us = require('./translations/en-us.json');
const ger = require('./translations/ger.json');
const enEu = require('./translations/en-EU.json');
const fr = require('./translations/fr.json');
const en_MY = require('./translations/en-my.json');
const enAr = require('./translations/en-ar.json');
const pt = require('./translations/pt.json');
const ru = require('./translations/ru.json');
const vi = require('./translations/vi.json');
const sp = require('./translations/sp.json');
const enAramexVw = require('./translations/en-ARAMEXVW.json');
const ypAr = require('./translations/yp-ar.json');
// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en,
    hi,
    ar,
    ba,
    us,
    ger,
    'en-EU': enEu,
    fr,
    en_MY,
    en_ar: enAr,
    pt,
    ru,
    vi,
    sp,
    'en-ARAMEXVW': enAramexVw,
    'yp-ar': ypAr,
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        ns: ['translation'],
        fallbackLng: 'en',
        resources,
        debug: false,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        detection: {
            order: ['localStorage'],
            lookupLocalStorage: 'lng',
        },
    });

export default i18n;
